(() => {
  const pageType = document.currentScript.dataset.pageType;
  const normalizeSearchParams = (value) => {
    const params = new URLSearchParams(value);
    if (pageType === 'collection') params.set('filter.v.availability', '1');
    if (pageType === 'search') params.set('options[unavailable_products]', 'hide');
    return params.toString();
  };

  window.tomStockVisibility = { normalizeSearchParams };

  if (pageType === 'collection' || pageType === 'search') {
    const current = new URLSearchParams(window.location.search).toString();
    const filtered = normalizeSearchParams(current);
    if (current !== filtered) {
      window.location.replace(`${window.location.pathname}?${filtered}${window.location.hash}`);
    }
  }

  const normalizeLink = (link) => {
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.origin !== window.location.origin) return;
    if (/\/collections\/[^/]+(?:\/[^/]+)?\/?$/.test(url.pathname) && !url.pathname.includes('/products/')) {
      url.searchParams.set('filter.v.availability', '1');
      link.href = url.toString();
    } else if (/\/search\/?$/.test(url.pathname)) {
      url.searchParams.set('options[unavailable_products]', 'hide');
      link.href = url.toString();
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href]').forEach(normalizeLink);
    document.addEventListener('click', (event) => {
      if (event.target instanceof Element) normalizeLink(event.target.closest('a[href]'));
    }, true);
  });
})();
